import { parseHandover } from "../../../shared/handover/line.ts";

export { parseHandover };

/** Who said each user message: `first` until a handover line names someone else. */
export function speakerNames(texts: string[], first: string): string[] {
	let speaker = first;
	return texts.map((text) => (speaker = parseHandover(text)?.to ?? speaker));
}
